import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    @Inject('environment') private environment: any,
    private http: HttpClient
  ) {}

  getProducts() {
    return this.http.get(`${this.environment.apiUrl}products/all`);
  }

  getUserDetail(id: any): Observable<any> {
    return this.http.get(`${this.environment.apiUrl}users/${id}`);
  }
  getUserDetailV2(id: any): Observable<any> {
    return this.http.get(
      `${this.environment.apiUrl}orders/collection-stats/${id}/1/1`
    );
  }

  updateUserData(data: any, id: string) {
    if (id) {
      return this.http.patch(`${this.environment.apiUrl}users/${id}`, data);
    } else {
      return this.http.post(`${this.environment.apiUrl}users`, data);
    }
  }
}
